import React from 'react';
var css = {
  "listContainer": "oalp-O070A",
  "heading": "oalp-2hQGm",
  "list": "oalp-11s_g",
  "listItem": "oalp-10xDr"
};
import { compose } from 'redux';
import classnames from 'classnames';
var ListContainer = function ListContainer(_ref) {
  var title = _ref.title,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    _ref$listContainerCla = _ref.listContainerClasses,
    listContainerClasses = _ref$listContainerCla === void 0 ? {} : _ref$listContainerCla;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.listContainer, listContainerClasses.containerClass)
  }, /*#__PURE__*/React.createElement("p", {
    className: classnames(css.heading, listContainerClasses.titleClass)
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: css.list
  }, list.map(function (item, key) {
    return /*#__PURE__*/React.createElement("li", {
      key: "document_".concat(key),
      className: classnames(css.listItem, listContainerClasses.listItemClass)
    }, item);
  })));
};
export default compose(React.memo)(ListContainer);